<div class="input-container">
  <label>{{ label | translate }} <span class="required" *ngIf="this.required === true">*</span></label>
  <div class="input-container__block" [class.validation-error]="isInvalid" [style.height]="inputHeight">
    <input
      [attr.type]="type || 'text'"
      [attr.readonly]="readonly"
      [attr.disabled]="disabled"
      [class.disabled]="disabled"
      [attr.placeholder]="placeholder | translate"
      [(ngModel)]="innerValue"
    />

    <div class="icons">
      <div class="validation-status">
        <span *ngIf="!isInvalid && value"></span>
        <span *ngIf="isInvalid && !isPassword && !isServerError" class="error-icon"></span>
      </div>
      <span class="eye-icon" (click)="changeType()" *ngIf="isPassword"></span>
      <span class="calendar-icon" *ngIf="type === 'calendar'"></span>
    </div>

    <div class="validation-error-text" *ngIf="control && control.errors && (control.dirty || control.touched)">
      <div *ngIf="(control.errors | first) === 'required'">
        <small>{{ 'VALIDATION_FIELD_IS_REQUIRED' | translate }}</small>
      </div>
      <div *ngIf="(control.errors | first) === 'mismatchedPasswords'">
        <small>{{ 'VALIDATION_PASSWORD_MISMATCH' | translate }}</small>
      </div>
      <div *ngIf="(control.errors | first) === 'minlength'">
        <small>{{ 'VALIDATION_FIELD_SHORT' | translate }}</small>
      </div>
      <div *ngIf="(control.errors | first) === 'maxlength'">
        <small>{{ 'VALIDATION_FIELD_LONG' | translate }}</small>
      </div>
      <div *ngIf="(control.errors | first) === 'email'">
        <small>{{ 'VALIDATION_EMAIL_FORMAT' | translate }}</small>
      </div>
    </div>
  </div>
</div>
